import PrincipalInformation from "./principal-information";

export default PrincipalInformation;
